import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Comps, Preview } from '@pages'
import { Header } from '@components/common'

const Routes = () => (
  <React.Fragment>
    <Header />
    <Switch>
      <Route exact path="/comps" component={Comps} />
      <Route exact path="/preview/:projectId?" component={Preview} />
      <Redirect from="/" to="/comps" />
    </Switch>
  </React.Fragment>
)

export default Routes
